import { NavBar, type INavBarOptions } from '@opengov/components-nav-bar';
import { useShellContributions } from '../../services/shellBridge/useShellContributions';
import { TestIds } from '../../constants';

/**
 * PSP-owned NavBar driven by the active routed remote's `remoteNav` contribution.
 * Mounted by RemoteAppShell when `psp-ui-shell-remote-nav` is enabled. Renders
 * nothing until that app has pushed config.
 *
 * Cast: `RemoteNavConfig.loggerOutput` is intentionally `unknown` in the contract
 * (avoids coupling to logger package types); NavBar expects its concrete union.
 */
export function ShellRemoteNavBar() {
  const { remoteNav } = useShellContributions();
  if (!remoteNav) return null;
  return (
    <div data-testid={TestIds.SHELL_REMOTE_NAV_BAR}>
      <NavBar {...(remoteNav as INavBarOptions)} />
    </div>
  );
}
